module.exports = __webpack_public_path__ + "static/media/ntakirutimana_masaka2.b0ee61ac.png";